import { Component } from "@angular/core";
import { I18nService } from "src/app/services/i18n.service";
import { Observable } from "rxjs";
import { SessionService } from "../../../../services/session.service";
import { ProfileService } from "../../../../services/profile.service";

@Component( {
	selector: "app-language-navbar",
	templateUrl: "./language-navbar.component.html",
	styleUrls: [ "./language-navbar.component.scss" ]
} )
export class LanguageNavbarComponent {
	currentLanguage: Observable<string>;

	constructor(
		private i18nService: I18nService,
		private sessionService: SessionService,
		private profileService: ProfileService
	) { }

	/**
	* Change language function
	* @param language : language string
	*/
	changeLanguage(language: string): void {
		this.i18nService.switchLanguage(language);
		if (this.sessionService.isAuthenticated()) {
			this.profileService.updateUser({ preferredLanguage: language }).subscribe({
				next: value => {},
				error: err => console.error(err)
			});
		}
	}

	ngOnInit() {
		this.currentLanguage = this.i18nService.currentLanguage.asObservable();
	}
}
